import {
  DashboardConfirmationPage,
  DashboardCustomerPage,
  DashboardPage
} from '#pages';
import { DashboardChartPage } from '#pages/DashboardChart/page';
import { DashboardChartFormEditPage } from '#pages/DashboardChartForm/Edit/page';
import { DashboardChartFormPage } from '#pages/DashboardChartForm/page';
import DashboardCustomerInfo from '#pages/DashboardCustomerInfo';
import { DashboardCustomerMembershipPage } from '#pages/DashboardCustomerMembership';
import MembershipSearchLecturePage from '#pages/DashboardCustomerMembership/components/SearchLecture';
import DashboardMembership from '#pages/DashboardMembership';
import { DashboardSettingPage } from '#pages/DashboardSetting';
import PaymentRequestPage from '#pages/PaymentRequest';
import { ReviewRequestPage } from '#pages/ReviewRequest';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

export function DashboardView() {
  return (
    <Routes>
      <Route path="" element={<DashboardPage />} />
      <Route path="/setting" element={<DashboardSettingPage />} />
      <Route
        path={`/customer/membership/:personId`}
        element={<DashboardCustomerMembershipPage />}
      />
      <Route
        path="/customer/membership/:personId/:confirmationFormId"
        element={<DashboardMembership />}
      />
      <Route
        path="/customer/:personId/info"
        element={
          <Suspense fallback={<div></div>}>
            <DashboardCustomerInfo />
          </Suspense>
        }
      />
      <Route
        path={`/customer/membership/search-lecture`}
        element={<MembershipSearchLecturePage />}
      />
      <Route
        path="customer/*"
        element={
          <Routes>
            <Route path="" element={<DashboardCustomerPage />} />
            <Route
              path="confirmation"
              element={<DashboardConfirmationPage />}
            />
            <Route path="review-request" element={<ReviewRequestPage />} />
            <Route path="payment-request" element={<PaymentRequestPage />} />
          </Routes>
        }
      />
      <Route
        path="chart/*"
        element={
          <Routes>
            <Route path="/" element={<DashboardChartPage />} />
            <Route path="form" element={<DashboardChartFormPage />} />
            <Route path="form/edit" element={<DashboardChartFormEditPage />} />
          </Routes>
        }
      />
    </Routes>
  );
}
